import { NotificationSeverity } from '@cast/types';

export const NOTIFICATIONS_FILTERS_STORAGE_KEY =
  'console.notifications.filters';

export const KnownSeverities = Object.values(NotificationSeverity).filter(
  (severity) => severity !== NotificationSeverity.UNSPECIFIED
);
